import { render } from "./static.vue?vue&type=template&id=366649ea&scoped=true&ts=true"
import script from "./static.vue?vue&type=script&lang=ts"
export * from "./static.vue?vue&type=script&lang=ts"

import "./static.vue?vue&type=style&index=0&id=366649ea&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366649ea"]])

export default __exports__